export type DocumentType = 'deck' | 'proposal' | 'one_pager' | 'brief' | 'page';
export type DocumentStatus = 'draft' | 'published' | 'archived';

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  deck: 'Deck',
  proposal: 'Proposal',
  one_pager: 'One-pager',
  brief: 'Brief',
  page: 'Page',
};

export interface DocumentSummary {
  id: string;
  type: DocumentType;
  title: string;
  slug: string | null;
  status: DocumentStatus;
  external_url: string | null;
  prospect_id: string | null;
  client_id: string | null;
  company_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface DocumentShare {
  id: string;
  public_token: string;
  recipient_label: string | null;
  expires_at: string | null;
  revoked: boolean;
  created_at: string;
}

export interface DocumentDetail extends DocumentSummary {
  content: unknown;
  raw_markdown: string | null;
  shares: DocumentShare[];
}

export interface DocumentEngagementRow {
  share_id: string;
  recipient_label: string | null;
  view_count: number;
  last_viewed_at: string | null;
}

export interface CreateDocumentInput {
  type: DocumentType;
  title: string;
  external_url?: string | null;
  content?: unknown;
  raw_markdown?: string | null;
  status?: DocumentStatus;
  prospect_id?: string | null;
  client_id?: string | null;
  company_id?: string | null;
}
